import {EVENT_ENDPOINTS} from './endpoints';
import {fetchData} from "../../Utils/fetchData";
import {IEvent, IEventCreate, IEventUpdate} from "../models/event";
import authToken from "../../Utils/authToken";
import {ApiResponse} from "../../types/api.types";

export const EventAPI = {
    create: async (data: IEventCreate): Promise<IEvent> => {
        const response = await fetchData(EVENT_ENDPOINTS.CREATE, {
            method: 'POST',
            headers: {
                "Content-type": "application/json",
                Authorization: authToken(),
            },
            body: JSON.stringify(data)
        }, 2);

        return response.json();
    },

    update: async (data: IEventUpdate): Promise<ApiResponse<IEvent>> => {
        const response = await fetchData(EVENT_ENDPOINTS.UPDATE, {
            method: 'PATCH',
            headers: {
                "Content-type": "application/json",
                Authorization: authToken(),
            },
            body: JSON.stringify(data)
        }, 2);
        return response.json();
    },

    delete: async (id: string): Promise<Response> => {
        return fetchData(EVENT_ENDPOINTS.DELETE, {
            method: 'DELETE',
            headers: {
                "Content-type": "application/json",
                Authorization: authToken(),
            },
            body: JSON.stringify({_id: id})
        }, 2);
    },

    fetchEvents: async (): Promise<ApiResponse<IEvent[]>> => {
        const response = await fetchData(EVENT_ENDPOINTS.FETCH_EVENTS, {
            method: "GET",
            headers: {
                Authorization: authToken(),
            },
        }, 2);

        return response.json();
    }

};